import React from "react";
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import validator from 'validator';
import { Paper, createStyles, TextInput, PasswordInput, Input, Button, Title, Text, Anchor, rem, Group } from '@mantine/core';
import { notifications } from '@mantine/notifications';

import { useLoginContext } from "../../context/loginContext";
import { useLoginContextSU } from "../../context/loginContextSU";

import { utils, brand, BE_API_SU_ONE } from "../../utils/globalVariables";
import { regexNoSpace, safetyDecodeJWT, getPropInSubLevelJWT } from "../../utils/globalFunctions";

import ModalResponse from "../../components/general/ModalResponse";
import imageLoginPage from "../../assets/images/login_page_9.jpg";

import ForgotPasswordFirstStepSU from "./ForgotPasswordFirstStepSU";

const useStyles = createStyles((theme) => ({
    wrapper: {
        minHeight: '100vh',
        backgroundSize: 'cover',
        backgroundImage: `url(${imageLoginPage})`,
    },

    form: {
        borderRight: `${rem(1)} solid ${theme.colorScheme === utils.theme.dark.slug ? theme.colors.dark[8] : theme.colors.gray[3]}`,
        minHeight: '100vh',
        maxWidth: rem(400),
        paddingTop: rem(80),
        backgroundColor: theme.colorScheme === utils.theme.dark.slug ? theme.colors.dark[8] : '#fff',

        label: {
            color: theme.colorScheme === utils.theme.dark.slug ? theme.colors.gray[3] : theme.colors.gray[7]
        },

        [theme.fn.smallerThan('sm')]: {
            maxWidth: '100%',
        },
    },

    title: {
        color: theme.colorScheme === utils.theme.dark.slug ? theme.colors.gray[3] : theme.colors.dark[8],
    },

    anchorForgotPassword: {
        color: theme.colorScheme === utils.theme.dark.slug ? theme.colors.gray[3] : theme.colors.gray[7],
        textDecoration: 'none',

        '&:hover': {
            textDecoration: 'none',
        }
    },

    buttonSignIn: {
        border: 0,
        '&[data-disabled=true]': {
            color: theme.colors.gray[6]
        }
    }
}));

const LoginIndexSuperUser = () => {

    const mountedRef = React.useRef(true);
    const { classes } = useStyles();
    const navigate = useNavigate();

    const { handleSetLoginContext } = useLoginContext();
    const { handleSetLoginContextSU } = useLoginContextSU();

    const notificationId = {
        loginSubmit: 'loginIndexSuperUser-1'
    }

    const [data, setData] = React.useState({
        userUserName: {
            id: 'loginPageUserUserNameSU',
            label: 'Username',
            withAsterisk: false,
            placeholder: 'Username',
            value: 'superuser',
            description: 'Username : superuser',
            error: ''
        },

        userPassword: {
            id: 'loginPageUserPasswordSU',
            label: 'Password',
            withAsterisk: false,
            placeholder: 'Your Password',
            value: '123',
            description: 'Password : 123',
            error: ''
        },

        submitLoading: false,

        lupaPasswordModalShow: false,

        forgotPassword: {
            modal: false,
        },

        modalResponse: {
            show: false,
            type: utils.modalResponse.warning,
            hideOnClickOutSide: false,
            content: ''
        }
    });

    React.useEffect(() => {
        document.title = 'Sign In Super User Aplikasi ' + brand.longName;

        return () => {
            mountedRef.current = false;
        };
    }, []);

    // const handleStorageChange = (e) => {
    //     if (e.key === utils.localStorageName.login) {
    //         console.log(JSON.parse(e.newValue));
    //     }
    // };

    // React.useEffect(() => {
    //     window.addEventListener('storage', handleStorageChange);

    //     return () => {
    //         window.removeEventListener('storage', handleStorageChange);
    //     };
    // }, []);

    const useHandleSubmit = () => {
        if (JSON.parse(window.localStorage.getItem(utils.localStorageName.login))) {
            setData(d => ({
                ...d,
                modalResponse: {
                    ...d.modalResponse,
                    type: utils.modalResponse.warning,
                    hideOnClickOutSide: true,
                    content: <React.Fragment>
                        <Text size='sm' color='dimmed'>
                            Anda masih sign in menggunakan akun {safetyDecodeJWT(JSON.parse(window.localStorage.getItem(utils.localStorageName.login)), 'syswebapp', 'syswebappn')} - {getPropInSubLevelJWT(JSON.parse(window.localStorage.getItem(utils.localStorageName.login)), 'caption', '')}. Sign out terlebih dahulu pada akun tersebut.
                        </Text>
                    </React.Fragment>,
                    show: true
                }
            }))
        } else {
            handleSetLoginContext(null);

            notifications.hide(notificationId.loginSubmit);

            setData(d => ({
                ...d,
                userUserName: { ...d.userUserName, error: '' },
                userPassword: { ...d.userPassword, error: '' },
            }));

            if (validator.isEmpty(data.userUserName.value, { ignore_whitespace: true })) {
                setData(d => ({ ...d, userUserName: { ...d.userUserName, error: ' ', } }));
            } else if (validator.isEmpty(data.userPassword.value, { ignore_whitespace: true })) {
                setData(d => ({ ...d, userPassword: { ...d.userPassword, error: ' ', } }));
            } else {
                setData(d => ({ ...d, submitLoading: true }));

                const formDT = new FormData();
                const formDTHeader = { 'Content-Type': 'application/json' }

                formDT.append('username', data.userUserName.value);
                formDT.append('password', data.userPassword.value);

                axios({
                    method: 'post',
                    url: BE_API_SU_ONE + '/authentication_signin_su',
                    data: formDT,
                    headers: formDTHeader,
                }).then((response) => {
                    if (!mountedRef.current) return null;

                    setData(d => ({ ...d, submitLoading: false }));

                    if (response.data.flag_status === 'isset') {
                        handleSetLoginContextSU(response.data.data);

                        // navigate ini kyk nya ga di eksekusi
                        navigate(`/superuser`, { replace: true });
                    }

                    if (response.data.flag_status === 'username-tidak-ada') {
                        notifications.show({
                            id: notificationId.loginSubmit,
                            title: utils.notification.warning.caption,
                            message: 'Akun tidak terdaftar',
                            color: utils.notification.warning.color,
                            icon: utils.notification.warning.icon,
                            withBorder: true,
                            autoClose: true,
                        })
                    }

                    if (response.data.flag_status === 'wrong-password') {
                        notifications.show({
                            id: notificationId.loginSubmit,
                            title: utils.notification.warning.caption,
                            message: 'Password salah !',
                            color: utils.notification.warning.color,
                            icon: utils.notification.warning.icon,
                            withBorder: true,
                            autoClose: true,
                        })
                    }
                }).catch(error => {
                    if (!mountedRef.current) return null;

                    setData(d => ({ ...d, submitLoading: false }));

                    notifications.show({
                        id: notificationId.loginSubmit,
                        title: utils.notification.warning.caption,
                        message: error.message,
                        color: utils.notification.warning.color,
                        icon: utils.notification.warning.icon,
                        withBorder: true,
                        autoClose: true,
                    })
                })
            }
        }
    }

    return (
        <React.Fragment>
            <div className={`${classes.wrapper}`}>
                <Paper className={classes.form} radius={0} p={30}>
                    <Title order={3} className={classes.title} ta="center" mt="md" mb={50}>
                        <Text>{brand.appName}</Text>
                        <Text size='sm' tt='uppercase'>Super User</Text>
                    </Title>

                    <Input.Wrapper
                        id={data.userUserName.id}
                        size="sm"
                        withAsterisk={data.userUserName.withAsterisk}
                        label={data.userUserName.label}
                        description={data.userUserName.description}
                    >
                        <TextInput
                            id={data.userUserName.id}
                            variant="filled"
                            placeholder={data.userUserName.placeholder}

                            value={data.userUserName.value}
                            onChange={(e) => setData(d => ({
                                ...d,
                                userUserName: {
                                    ...d.userUserName,
                                    value: regexNoSpace(e.target.value)
                                }
                            }))}
                            // onKeyUp={(e) => e.key === 'Enter' && !data.submitLoading && useHandleSubmit()}

                            error={data.userUserName.error}
                        />
                    </Input.Wrapper>

                    <Input.Wrapper
                        id={data.userPassword.id}
                        size="sm"
                        mt="md"
                        withAsterisk={data.userPassword.withAsterisk}
                        label={data.userPassword.label}
                        description={data.userPassword.description}
                    >
                        <PasswordInput
                            id={data.userPassword.id}
                            variant="filled"
                            placeholder={data.userPassword.placeholder}

                            value={data.userPassword.value}
                            onChange={(e) => {
                                setData(d => ({
                                    ...d,
                                    userPassword: {
                                        ...d.userPassword,
                                        value: regexNoSpace(e.target.value)
                                    }
                                }))
                            }}
                            // onKeyUp={(e) => e.key === 'Enter' && !data.submitLoading && useHandleSubmit()}

                            error={data.userPassword.error}
                        />
                    </Input.Wrapper>

                    <Group
                        position="apart"
                        mt='lg'
                    >
                        <Text size='sm'>
                            <Anchor
                                className={classes.anchorForgotPassword}
                                href="#"
                                onClick={(e) => {
                                    e.preventDefault();
                                    setData(d => ({ ...d, forgotPassword: { ...d.forgotPassword, modal: true } }))
                                }}
                            >
                                Forgot password ?
                            </Anchor>
                        </Text>

                        <Button
                            size="sm"
                            className={classes.buttonSignIn}
                            px='1.5rem'
                            variant='light'
                            color="red"
                            disabled={data.submitLoading}

                            onClick={useHandleSubmit}
                        >
                            {data.submitLoading ? 'Sign In' : 'Sign In'}
                        </Button>
                    </Group>
                </Paper>
            </div>

            <ModalResponse
                stateShow={data.modalResponse.show}
                fnHide={() => setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        show: false
                    }
                }))}

                stateHideOnClickOutSide={data.modalResponse.hideOnClickOutSide}
                stateType={data.modalResponse.type}
                stateContent={data.modalResponse.content}
            />

            <ForgotPasswordFirstStepSU
                stateShow={data.forgotPassword.modal}
                fnHide={() => setData(d => ({ ...d, forgotPassword: { ...d.forgotPassword, modal: false } }))}
            />
        </React.Fragment>
    )
}

export default LoginIndexSuperUser;